
import { useEffect, useRef, useState } from 'react';
import { mapquestFetch, incrementTransaction } from './MapQuestFetch';

const MapView = ({ from, stops = [], to, onMileageCalculated, onTimeOutCalculated }) => {
  const [info, setInfo] = useState({ miles: '', time: '' });
  const mapRef = useRef(null);
  const directionsLayerRef = useRef(null);

  useEffect(() => {
    if (!from || !to) return;

    // API key
    window.L.mapquest.key = '4H727f3Nq5ymaqNEeszFgjGOtY0tkiK7';

    const container = window.document.getElementById('map');
    if (container && container._leaflet_id) {
      container._leaflet_id = null; // evita error de “map already initialized”
    }

    if (!mapRef.current) {
      mapRef.current = window.L.mapquest.map('map', {
        center: [29.4241, -98.4936],
        layers: window.L.mapquest.tileLayer('map'),
        zoom: 10,
      });
    }

    const sanitize = (addr) =>
      typeof addr === 'string' ? addr.trim() : '';

    const allStops = Array.isArray(stops)
      ? stops.filter(s => sanitize(s)).map(sanitize)
      : typeof stops === 'string' && sanitize(stops)
        ? [sanitize(stops)]
        : [];

    const allLocations = [sanitize(from), ...allStops, sanitize(to)].filter(Boolean);
    window.L.mapquest.directions().route(
      {
        routeType: 'fastest',
        locations: allLocations,
      },
      (error, response) => {

        if (response) {
          incrementTransaction();
        }

        directionsLayerRef.current = window.L.mapquest.directionsLayer({
          directionsResponse: response,
        }).addTo(mapRef.current);
      }
    );


    // También pedimos los datos con fetch para millas y tiempo
    mapquestFetch(
      `https://www.mapquestapi.com/directions/v2/route?key=4H727f3Nq5ymaqNEeszFgjGOtY0tkiK7`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          locations: allLocations,
          options: { unit: 'm' },
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const route = data?.route;
        if (route && route.distance && route.formattedTime) {
          setInfo({
            miles: route.distance.toFixed(2),
            time: route.formattedTime,
          });

          if (onMileageCalculated) onMileageCalculated(route.distance.toFixed(2));
          if (onTimeOutCalculated) onTimeOutCalculated(route.formattedTime);
        }
      });
  }, [from, stops, to]);

  return (
    <div id="map-container" style={{ position: 'relative', marginBottom: '1rem' }}>
      <div id="map" style={{ height: '400px', width: '100%' }} />

      {/* Mostrar millas y tiempo sobre el mapa */}
      {info.miles && info.time && (
        <p style={{ color: 'gray' }}>
          From: {from}<br />
          {stops && stops.length > 0 && (
            <>
              Stops:<br />
              {stops.map((stop, index) => (
                <span key={index}>• {stop}<br /></span>
              ))}
            </>
          )}
          To: {to}<br />
          Miles:{info.miles} mi<br />
          Time: ⏱{info.time}
        </p>

      )}


    </div>
  );
};

export default MapView;


